import Styles from './CompleteCard.module.scss';
import * as React from 'react';

// Module imports
import {
    ListItem, ListItemText, ListItemAvatar,
    List, Paper, ListSubheader, Grow
} from '@mui/material';

// Components import.
import { useTranslation } from 'components/lib';

// Assets imports.
import TestCaseIcon from 'assets/icons/testCases.png';
import ScoreIcon from 'assets/icons/points.png';
import GoldIcon from 'assets/icons/gold.png';
import SilverIcon from 'assets/icons/silver.png';
import BronzeIcon from 'assets/icons/bronze.png';
import FailIcon from 'assets/icons/fail.png';
import TimeIcon from 'assets/icons/timeTaken.png';
import HintsIcon from 'assets/icons/hints.png';

export function CompleteCard(props) {

    const { t } = useTranslation();
    let medalIcon;
    if (props.percentage >= 90) {
        medalIcon = GoldIcon;
    } else if (props.percentage >= 80) {
        medalIcon = SilverIcon;
    } else if (props.percentage >= 70) {
        medalIcon = BronzeIcon;
    } else {
        medalIcon = FailIcon;
    }

    const timeTaken = props.timeTaken ? props.timeTaken : 'Calculating...';
    const pointsScored = props.score !== null ? props.score : 'Calculating...';

    return (
        <Grow in>
            <div style={{ width: '100%', maxWidth: 360 }}>
                <List
                    // sx={{ bgcolor: 'background.paper' }}
                    className={Styles.challengeSummary}
                    subheader={
                        <ListSubheader
                            component="div"
                            id="nested-list-subheader"
                            sx={{
                                fontWeight: "bold",
                                fontSize: "large",
                                bgcolor: "transparent",
                                
                            }}
                        >
                            {t('Streams.ChallengeLevelOne.ChallengeLevelOne.completeCard.list.subHeader')} </ListSubheader>
                    }
                >
                    <Paper elevation={3} className={Styles.challengeSummaryCards} sx={{ bgcolor: '#ffebee' }}>
                        <ListItem>
                            <ListItemAvatar>
                                <img src={TestCaseIcon} alt="testcases" width="48" height="48" />
                            </ListItemAvatar>
                            <ListItemText secondary={t('Streams.ChallengeLevelOne.ChallengeLevelOne.completeCard.list.items.uncovered')} primary={`${props.numTestUncovered}/${props.totalTestCases}`} />
                        </ListItem>
                    </Paper>
                    <Paper elevation={3} className={Styles.challengeSummaryCards} sx={{ bgcolor: '#ffebee' }}>
                        <ListItem>
                            <ListItemAvatar>
                                <img src={ScoreIcon} alt="score" width="48" height="48" />
                            </ListItemAvatar>
                            <ListItemText primary={pointsScored} secondary={t('Streams.ChallengeLevelOne.ChallengeLevelOne.completeCard.list.items.points')} />
                        </ListItem>
                    </Paper>
                    <Paper elevation={3} className={Styles.challengeSummaryCards} sx={{ bgcolor: '#ffebee' }}>
                        <ListItem>
                            <ListItemAvatar>
                                <img src={medalIcon} alt="medal" width="48" height="48" className={Styles.icon} />
                            </ListItemAvatar>
                            <ListItemText secondary={t('Streams.ChallengeLevelOne.ChallengeLevelOne.completeCard.list.items.eligible')} primary={`${props.percentage}%`} />
                        </ListItem>
                    </Paper>
                    <Paper elevation={3} className={Styles.challengeSummaryCards} sx={{ bgcolor: '#ffebee' }}>
                        <ListItem>
                            <ListItemAvatar>
                                <img src={TimeIcon} alt="time" width="48" height="48" />
                            </ListItemAvatar>
                            <ListItemText secondary={t('Streams.ChallengeLevelOne.ChallengeLevelOne.completeCard.list.items.time')} primary={timeTaken} />
                        </ListItem>
                    </Paper>
                    <Paper elevation={3} className={Styles.challengeSummaryCards} sx={{ bgcolor: '#ffebee' }}>
                        <ListItem>
                            <ListItemAvatar>
                                <img src={HintsIcon} alt="hints" width="48" height="48" />
                            </ListItemAvatar>
                            <ListItemText secondary={t('Streams.ChallengeLevelOne.ChallengeLevelOne.completeCard.list.items.hints')} primary={props.hints} />
                        </ListItem>
                    </Paper>
                </List>
            </div>
        </Grow >
    );
}